import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import TransparentButton from "../../button/TransparentButton";
var CategoryLink = styled(TransparentButton).attrs({
    $size: "small"
}).withConfig({
    componentId: "sc-4357b6ca-0"
})(_templateObject());
export default CategoryLink;
